import React from 'react';
import Container from './Container';
import useScrollAnimation from '../hooks/useScrollAnimation';

const AboutMissionVision = () => {
  const leftRef = useScrollAnimation('scroll-animate-left');
  const visionRef = useScrollAnimation('scroll-animate-right');
  const missionRef = useScrollAnimation('scroll-animate-left');

  return (
    <section id="vision-mission" className="about-mission-vision section alt">
      <Container>
        <div className="mission-vision-content">
          <div ref={leftRef} className="what-drives-us left-panel scroll-animate-left">
            <h2 className="text-xl md:text-2xl lg:text-3xl">What Drives Us Forward</h2>
            <div className="truck-illustration">
              <img src="/images/truck.svg" alt="Illustration of a logistics truck" />
            </div>
          </div>
          <div className="right-panel">
            <div ref={visionRef} className="row vision-row scroll-animate-right">
              <div className="vision-image">
                <img src="/images/drive_us_forward_vision.webp" alt="Vision - Global Network" loading="lazy" decoding="async" />
              </div>
              <div className="vision-text">
                <h3 className="text-lg md:text-xl lg:text-2xl">Vision</h3>
                <p className="text-sm md:text-base lg:text-lg">To be recognised as India's most dependable logistics partner, leveraging innovation, technology, and service excellence to connect businesses nationwide.</p>
              </div>
            </div>
            <div ref={missionRef} className="row mission-row scroll-animate-left">
              <div className="mission-text">
                <h3 className="text-lg md:text-xl lg:text-2xl">Mission</h3>
                <p className="text-sm md:text-base lg:text-lg">To provide reliable, timely, and cost-effective logistics solutions that ensure seamless movement of goods while building long-lasting trust with our customers.</p>
              </div>
              <div className="mission-image">
                <img src="/images/drive_us_forward_mission.webp" alt="Mission - Logistics Operations" loading="lazy" decoding="async" />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default AboutMissionVision;
